(function () {
  var root = document.getElementById('ml-reviews');
  if (!root) return;
  var KEY = root.getAttribute('data-kb-client');
  var BID = root.getAttribute('data-kb-business');
  var PID = root.getAttribute('data-kb-product');
  if (!KEY || !BID || !PID) return;

  var grid = root.querySelector('[data-grid]');
  var moreBtn = root.querySelector('[data-more]');
  var noteEl = root.querySelector('[data-note]');
  if (!grid) return;

  var all = [], seen = {}, shown = 0, PAGE = 12;

  function text(r) { return r && r.message ? String(r.message).trim() : ''; }

  function usable(r) {
    if (!r || !r.id) return false;
    if (r.state && r.state.type && r.state.type !== 'published') return false;
    var m = text(r);
    if (!m) return false;
    if (/^rated\s+\d\s+stars?/i.test(m)) return false;
    return true;
  }

  function dupeKey(r) {
    var who = ((r.reviewer && r.reviewer.display_name) || '').trim().toLowerCase();
    return 'k:' + who + '|' + text(r).toLowerCase().replace(/\s+/g, ' ');
  }

  function when(r) { return r.created_at_platform || r.created_at || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function fmt(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function card(r) {
    var pct = Math.max(0, Math.min(100, (Number(r.rating) || 0) * 20));
    var name = (r.reviewer && r.reviewer.display_name) ? r.reviewer.display_name : 'Verified customer';
    var verified = r.reviewer && r.reviewer.verified;
    var date = fmt(when(r));
    var tags = (r.tags || []).slice(0, 3);
    var h = '<li class="mlrv__card">';
    h += '<span class="mlrv-stars" style="--mlrv-p:' + pct + '%" role="img" aria-label="' + (Number(r.rating) || 0) + ' out of 5 stars">';
    h += '<span class="mlrv-stars__bg" aria-hidden="true">★★★★★</span>';
    h += '<span class="mlrv-stars__fg" aria-hidden="true">★★★★★</span></span>';
    h += '<blockquote class="mlrv__quote">' + esc(text(r)).replace(/\n/g, '<br>') + '</blockquote>';
    if (tags.length) {
      h += '<ul class="mlrv__tags">';
      for (var i = 0; i < tags.length; i++) h += '<li>' + esc(tags[i]) + '</li>';
      h += '</ul>';
    }
    h += '<p class="mlrv__by"><span class="mlrv__name">' + esc(name) + '</span>';
    if (verified) h += '<span class="mlrv__verified">Verified</span>';
    if (date) h += '<span class="mlrv__date">' + date + '</span>';
    h += '</p></li>';
    return h;
  }

  function renderMore() {
    var next = all.slice(shown, shown + PAGE);
    var html = '';
    for (var i = 0; i < next.length; i++) html += card(next[i]);
    grid.insertAdjacentHTML('beforeend', html);
    shown += next.length;
    if (moreBtn) moreBtn.hidden = shown >= all.length;
    if (noteEl) {
      noteEl.textContent = shown >= all.length
        ? ''
        : 'Showing ' + shown + ' of ' + all.length + ' reviews.';
    }
  }

  if (moreBtn) moreBtn.addEventListener('click', renderMore);

  var u = new URL('https://api.kudobuzz.com/v1/reviews');
  u.searchParams.set('client_id', KEY);
  u.searchParams.set('business_id', BID);
  u.searchParams.set('state', 'published');
  u.searchParams.set('limit', '100');
  u.searchParams.set('external_unique_id', PID);

  fetch(u.toString())
    .then(function (r) { return r.ok ? r.json() : { data: [] }; })
    .then(function (j) {
      var list = j.data || [];
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (!usable(r)) continue;
        var k = dupeKey(r);
        if (seen[k]) continue;
        seen[k] = 1;
        all.push(r);
      }
      if (!all.length) return;
      all.sort(function (a, b) { return String(when(b)).localeCompare(String(when(a))); });
      grid.innerHTML = '';
      shown = 0;
      renderMore();
    })
    .catch(function () {});
})();